/**
 * ProfiloPage — F-002 Phase 4 (IMPL-P4-012).
 *
 * Container per la route `/app/profilo`. Wrappa il `BillingProfileForm`
 * dentro `AppLayout` + `RequireAuth` (qualunque ruolo autenticato può
 * gestire il proprio profilo di fatturazione).
 *
 * Heading + sub-heading allineati al pattern di {@link PraticheDashboard}.
 */
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireAuth } from '@/features/auth/components/RequireAuth';

import { BillingProfileForm } from '../components/BillingProfileForm';

export function ProfiloPage() {
  return (
    <RequireAuth>
      <AppLayout>
        <section className="space-y-6">
          <header className="space-y-1">
            <h1 className="text-3xl font-semibold tracking-tight">Il tuo profilo</h1>
            <p className="text-muted-foreground">
              Gestisci i dati anagrafici e di fatturazione necessari per la registrazione delle
              pratiche.
            </p>
          </header>

          <BillingProfileForm />
        </section>
      </AppLayout>
    </RequireAuth>
  );
}
